import templateConfig from './template.js';
import layoutConfig from './layout.js';
import totalConfig from './total.js';
import dataLabelsConfig from './dataLabels.js';
import nodesConfig from './nodes.js';
import minorValues from './minorValues.js';

const sankeyConfig = {
	tagName: 'VerticalLayout',
	children: [
		templateConfig,
		layoutConfig,
		totalConfig,
		dataLabelsConfig,
		nodesConfig,
		minorValues
	]
};

export default sankeyConfig;
